var _style, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoConfirmar01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_60",
    cx: 18,
    cy: 18,
    rx: 17.5,
    ry: 17.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1406",
    className: "st0",
    d: "M16.8,26.8l-8.3-6.5l2.4-3l5.1,4l8.4-12.1l3.2,2.2L16.8,26.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConfirmar01);
export default __webpack_public_path__ + "static/media/ico-confirmar-01.8ac504672d228b62509e0449b8948000.svg";
export { ForwardRef as ReactComponent };